const MANIFEST_THEMES = {
    holiday: {
        hashed: 'holiday.42df5b900f1a56d4437820ae1a3938fa.min.css',
        versioned: 'holiday.min.css'
    }
};

export { MANIFEST_THEMES };
